import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Alert } from "antd";
import Logo from "../../../assets/Images/AmericanClinic Online.svg";
import { setCategioryId } from "../../../Redux/Actions/GeneralActions";

const UrgentConfirmation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const RoomId = useParams();
  const user = useSelector((state) => state.auth.userData);

  useEffect(() => {
    dispatch(setCategioryId(null));
  }, [dispatch]);

  const handleJoinUrgentCare = (roomId, userId, contactType) => {
    navigate(
      `/video-chat?roomId=${roomId}&&name=${userId}&&type=urgent&&contactType=${contactType}`
    );
  };

  return (
    <div className="bg-[#edf2ff] min-h-[100vh] flex flex-col">
      <div className="w-full flex justify-center md:px-[50px] px-[20px] md:py-[3vh] py-[1vh]">
        <Link to="/">
          <img
            src={Logo}
            alt="American Clinic Online"
            height="150"
            width="150"
            className="object-contain"
          />
        </Link>
      </div>

      <div className="border-confirm"></div>

      <div className="flex-1 VideoBg md:px-[150px] px-[20px] md:pt-[80px] pt-[50px]">
        <div className="md:flex md:items-start items-center urgent-conformation-container">
          <div className="flex justify-center md:w-[45%] w-full">
            <img
              className="max-w-[250px] w-full h-auto object-contain"
              src="/images/videoConfirm.png"
              alt="Video Consultation Illustration"
            />
          </div>

          <div className="mb-10 md:mb-0 md:ml-[50px] w-full flex flex-col urgent-conformation-text-container">
            <h1 className="confirm-title text-left mt-[30px]">
              Urgent Care Consultation Booked!
            </h1>

            <p
              style={{ fontWeight: "600" }}
              className="confirm-text text-left mt-[10px] mb-3 leading-relaxed md:pr-[100px]"
            >
              Your payment has been received and your consultation request has
              been confirmed.
            </p>

            <div className="mt-[20px] md:pr-[100px] text-gray-700 text-left">
              <p className="font-bold mb-[8px] text-lg">
                Please follow these steps:
              </p>
              <ol className="list-decimal list-inside space-y-2 text-base mt-3 marker:font-bold">
                <li>
                  Click the button below to{" "}
                  <strong>enter the waiting room</strong>.
                </li>
                <li>
                  Once connected, you'll be placed in the{" "}
                  <strong>video meeting room</strong>.
                </li>
                <li>
                  Please <strong>stay in the room</strong> — one of our doctors
                  will join your session as soon as they are available.
                </li>
              </ol>
            </div>

            <div className="mt-[25px] md:pr-[100px]">
              <Alert
                message="Important"
                description={
                  <>
                    We've also sent the <strong>video meeting link</strong> to
                    your email address. You can use that link to join the
                    consultation if you prefer to access it from another device.
                  </>
                }
                type="info"
                showIcon
              />
            </div>

            <button
              onClick={() =>
                handleJoinUrgentCare(RoomId?.id, user?.user_id, "video")
              }
              className="btn-confirm md:mt-[25px] mt-[20px] mb-[20px]"
            >
              Join Waiting Room
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UrgentConfirmation;
